import { INITIAL_VALUES } from '../state';
import { flightReducer } from './flight';
import { hotelReducer } from './hotel';
import { tourReducer } from './tour';
import { carRentalReducer } from './car';

export const initialState = INITIAL_VALUES;

// combine all the reducers to this updated state
export const commonReducer = (state, action) => {
  state = {
    ...state,
    ...flightReducer(state, action),
    ...hotelReducer(state, action),
    ...tourReducer(state, action),
    ...carRentalReducer(state, action),
  };

  switch (action.type) {
    // switch case to check some common state manipulations - if any
    default:
      return state;
  }
};
